import { useId } from 'react';
import { Icon } from '@chakra-ui/react';

const CustomTemplateMultiIcon = (props) => {
  const clipId = `passTplClip-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;

  return (
    <Icon
      fill="none"
      {...props}
      viewBox="0 0 24 30"
      width="28.5px"
      height="28.5px"
      ml="-3.5px"
    >
      <defs>
        <clipPath id={clipId}>
          <rect width="23.619" height="30" rx="5" fill="white" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <path
          className="strokeBrandElToDark darkBgElToBrand"
          d="M12.7829 23.9665L18.2215 18.8673C18.4364 18.6745 18.7232 18.5683 19.0206 18.5714C19.318 18.5744 19.6023 18.6865 19.8126 18.8836C20.0229 19.0807 20.1426 19.3472 20.1459 19.626C20.1492 19.9048 20.036 20.1737 19.8304 20.3752L14.3909 25.4744C14.2668 25.5907 14.1087 25.67 13.9367 25.7023L12.1904 26.0298L12.5398 24.3923C12.5742 24.231 12.6588 24.0828 12.7829 23.9665Z"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          className="strokeBrandElToDark darkBgElToBrand"
          d="M17.3015 19.9883L18.6348 21.2383"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          fill="none"
        />
      </g>
      <rect
        className="strokeBrandElToDark darkBgElToBrand"
        x="0.75"
        y="0.75"
        width="22.119"
        height="28.5"
        rx="4.25"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        fill="none"
      />
      <line
        className="strokeBrandElToDark darkBgElToBrand"
        x1="1.52344"
        y1="6.39258"
        x2="23.6712"
        y2="6.39258"
        stroke="#FFFFFF"
        strokeWidth="1.5"
      />
      <line
        className="strokeBrandElToDark darkBgElToBrand"
        x1="1.5498"
        y1="14.25"
        x2="23.6975"
        y2="14.25"
        stroke="#FFFFFF"
        strokeWidth="1.5"
      />
    </Icon>
  );
};

export default CustomTemplateMultiIcon;
